import type { ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Renders an overlay at the end of the page instead of where it is declared.
 *
 * A dialog opened from inside another — the chat preview from the editor — or from inside
 * an animated page would otherwise sit in a box with a blur or a transform, and a fixed
 * element there is pinned to that box rather than to the screen: it scrolled away with it.
 */
export function Portal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
